import type {Optional, OptionalNullable} from "./TypeHelpers";

function _nonEmpty(value: OptionalNullable<string>): Optional<string> {
  return value !== undefined && value !== null && value.length > 0 ? value : undefined;
}

// This would work with the new TypeScript 5 decorators, but dcerialize doesn't support them.
// // eslint-disable-next-line @typescript-eslint/prefer-readonly-parameter-types
// export function nonEmpty<This extends object>(): (target: This, ctx: ClassFieldDecoratorContext<This, Optional<string>>) => void {
//   // eslint-disable-next-line @typescript-eslint/prefer-readonly-parameter-types
//   return function (target: This, ctx: ClassFieldDecoratorContext<This, Optional<string>>) {
//     // eslint-disable-next-line @typescript-eslint/unbound-method
//     const originalSetter = ctx.access.set;
//     ctx.access.set = function (object: This, newValue: Optional<string>): void {
//       originalSetter(object, _nonEmpty(newValue));
//     };
//     return _nonEmpty;
//   };
// }

const nonEmptyValueMap = new WeakMap<object, Map<string, string>>();

export function nonEmpty<This extends object>(target: This, keyName: string): void {
  Object.defineProperty(target, keyName, {
    get: function (this: This): Optional<string> {
      return nonEmptyValueMap.get(this)?.get(keyName);
    },
    set: function (this: This, value: Optional<string>): void {
      const newValue = _nonEmpty(value);
      const hasNewValue = newValue !== undefined;
      let targetMap = nonEmptyValueMap.get(this);
      if (!targetMap && hasNewValue) {
        targetMap = new Map<string, string>();
        targetMap.set(keyName, newValue);
        nonEmptyValueMap.set(this, targetMap);
      } else if (targetMap && hasNewValue) {
        targetMap.set(keyName, newValue);
      } else if (targetMap && !hasNewValue) {
        targetMap.delete(keyName);
        if (targetMap.size === 0) nonEmptyValueMap.delete(this);
      }
    },
  });
}
